import axios from "@/utils/axios";
import { getReport , sendTemplate , getReportToken , userInfoToken , get_modules , gov_report , wl_report , fivesix , congenital , dayin } from "@/api";
import { Notify , Toast } from 'vant';
import { audioPaly , pageFun , ask , syndrome } from "@/utils";
import { reportover } from "@/utils/audio";
import { transformReport } from "@/views/report/module/pipeline";
import { drawMeter, drawRadar, drawBroken, drawCake } from "@/views/report/module/chart";
import { getModuleNames, setModuleVersion } from "@/views/report/module/helpers";

// 第三方对接（立创/北京/温岭）
// 仅在收到报告数据后根据 testing_type 触发对应上报流程，拆到独立函数以避免污染 Axios 主流程
function handleThirdPartyCallback(store, data, flow) {
    const testing_type = flow && JSON.parse(flow) ? JSON.parse(flow).testing_type : 0;
    if(window.xiekangAndroidInterface){     //携康
        const callback_result_text = JSON.parse(data.callback_result_text);
        if (sessionStorage.info) {
            const user_info = JSON.parse(sessionStorage.info);
            const random = {
                TcmNo: `${user_info.random}`,
                personInfo: {
                    IdCard: data.idc,
                    Name: data.user_name,
                    Sex: data.sex == 1 ? '男' : (data.sex == 2 ? '女' : '未知'),
                    Birthday: data.birthday
                },
                createTime: data.created_at,
                tcmResult: {
                    PCaList: callback_result_text.PCaList,
                    QCaList: callback_result_text.QCaList
                },
                tmi: data.tizhi_content ? data.tizhi_content.tongue : '',
                report_url:`https://tz.saas.quanmai.cloud/report/${data.token}`
            };
            syndrome.map((item) => {
                callback_result_text.CasList.map((item1) => {
                    if (item.name == item1.CaName) {
                        random[item.key] = `${item1.CaScore}`;
                    }
                });
            });

            ask.map((item2) => {
                callback_result_text.QaList.map((item3) => {
                    if (item2.id == item3.Sn) {
                        random[item2.key] = `${item3.A}`;
                    }
                });
            });
            window.xiekangAndroidInterface.setResults(JSON.stringify({
                random: user_info.random,
                data: JSON.stringify(random)
            }));
        }
    }else if (testing_type == 5) {          // 立创
        const callback_result_text = JSON.parse(data.callback_result_text);
        if (sessionStorage.info) {
            const user_info = JSON.parse(sessionStorage.info);
            const random = {
                TcmNo: `${user_info.random}`,
                personInfo: {
                    IdCard: data.idc,
                    Name: data.user_name,
                    Sex: data.sex == 1 ? '男' : (data.sex == 2 ? '女' : '未知'),
                    Birthday: data.birthday
                },
                createTime: data.created_at,
                tcmResult: {
                    PCaList: callback_result_text.PCaList,
                    QCaList: callback_result_text.QCaList
                },
                tmi: data.tizhi_content ? data.tizhi_content.tongue : ''
            };

            syndrome.map((item) => {
                callback_result_text.CasList.map((item1) => {
                    if (item.name == item1.CaName) {
                        random[item.key] = `${item1.CaScore}`;
                    }
                });
            });

            ask.map((item2) => {
                callback_result_text.QaList.map((item3) => {
                    if (item2.id == item3.Sn) {
                        random[item2.key] = `${item3.A}`;
                    }
                });
            });

            window.ipcRenderer.send("fileJson", {
                random: user_info.random,
                data: JSON.stringify(random)
            });
        }
    } else if (testing_type == 6 && sessionStorage.govReport) {    // 北京
        const callback_result_text = JSON.parse(data.callback_result_text);
        const equipment = JSON.parse(sessionStorage.equipment);
        const random = {
            idCard: data.idc ? data.idc : '',
            name: data.user_name ? data.user_name : '',
            mac: equipment.mac,
            mainConstitution: callback_result_text.PCaList
        };

        random.scoreAndResults = callback_result_text.CasList.map((list) => ({
            constitutionName: list.CaName,
            constitutionScore: list.CaScore,
            constitutionResult: list.CaDr
        }));

        random.answers = callback_result_text.QaList
            .map((list1) => ({ sn: list1.Sn, question: list1.Q, answer: list1.A }))
            .sort((a, b) => a.sn - b.sn);

        store.dispatch('report/govReport', {
            token: sessionStorage.govReport,
            data: random
        });
    }else if (testing_type == 7) {        // 温岭
        const callback_result_text = JSON.parse(data.callback_result_text);
        const qaList = callback_result_text.QaList
            .map((list1) => ({ questionId: list1.Sn, answerId: list1.A }))
            .sort((a, b) => a.questionId - b.questionId);

        const data_wl = {
            head: {
                userid: 'HZQM',
                timestamp: new Date().getTime(),
                orgCode: '47272228',
                empCode: '10052',
                sign: '202cb962ac59075b964b07152d234b70'
            },
            request: {
                hcLogDtlList: qaList,
                hcLogMst: {
                    tcmTime: data.created_at,
                    idcard: data.idc,
                    operaDoctor: '10052',
                    orgCode: '47272228',
                    orgName: '温岭市滨海镇卫生院',
                    height: data.height,
                    weight: data.weight,
                    waist: data.fu_wei ? data.fu_wei : '',
                    assessDoctor: '10052',
                    assessDoctorName: '罗小苗',
                    interfaceSource: '6'
                }
            }
        };

        store.dispatch('report/wlReport', { data: data_wl });
    }
}

let report = {
    namespaced: true,
    state: {
        info:false,                             //报告数据存储        
        user:{},                                //个人信息数据存储
        module:{                                //模块数据存储   药茶养生等       
            renovate:true,
            data:[]
        },
        loading:false,                          //报告加载中状态
        login:false,                            //登录弹窗状态
        send:false,                             //发送报告弹窗状态
        prescribe:false,       
        doctor:false,                           //是否是医生
        page:0,                                 //页码   0是一整页显示 0以上是一页一题
        module_list:[],                         //选择发送模块的数据存储
        module_name:[],                         //用户发送模块的选择
        template_id:0,
        history:false,                          //历史记录弹窗状态
        xtjk:null,
        wylq:null,
        showModules: getModuleNames(),   //模块显示控制 - 根据数组决定加载哪些模块组件
    },
    mutations: {            //同步方法
        //清空数据
        closeFun(state){
            state.info = false;
            state.module = { renovate:true,data:[] }
            state.loading = false;
            state.login = false;
            state.send = false;
            state.page = 0;
            state.user = {};
            state.history = false;
        },
        //改变数值
        changeFun(state,data){
            state[data.key] = data.value;
        },
        //设置模块显示数组
        setShowModules(state,list){
            state.showModules = Array.isArray(list) ? list : [];
        },
        //一级目录
        change(state,params){
            let module = state.module.data;
            for(let item in module[params.index].description_list){
                module[params.index].description_list[item].active = false;
            }
            module[params.index].description_list[params.index1].active = true;
            state.module = {
                renovate:!state.module.renovate,
                data:module
            }
        },
        //二级目录
        changeTwo(state,params){
            let module = state.module.data;
            for(let item in module[params.index].description_list[params.index1].list){
                module[params.index].description_list[params.index1].list[item].active = false;
            }
            module[params.index].description_list[params.index1].list[params.index2].active=true;
            state.module = {
                renovate:!state.module.renovate,
                data:module
            }
        },
        //翻页 - 仅更新页码，图表绘制由各模块自己响应 page 变化完成
        pageChange(state,data){
            state.page = pageFun(data.page,data.add,state.info);
        },
        //仪表盘
        Meter(state,params){
            drawMeter(params.id, {
                color: params.color,
                score: params.score != null ? params.score : state.info && state.info.score
            });
        },

        //雷达图
        Radar(state,params){
            drawRadar(params.dom, params.data);
        },

        Send(state,params){
            axios(`/api${sendTemplate}`,{
                ...params.data,
                module_ids:state.module_name,
                template_id:state.template_id
            },'POST')
			.then((data)=>{
                if(data.code==1){
                    //语音
                    audioPaly.play(reportover);
                    state.send = false;
                    Toast.success('发送成功！');
                }else{
                    Notify(data.msg);
                }
            },function(error) {
                if(error.code==401){
                    Notify(error.msg);
                    state.login = true;
                }else{
                    Notify(error.msg);
                }
            });
        },

        //折线图
        Broken(state,params){
            drawBroken(params.dom, { date: params.date, data: params.data, max: params.max });
        },

        //饼状图
        Cake(state,params){
            drawCake(params.dom, params.data);
        },
        
        //请求
        User(state,params){
            axios(`/api${userInfoToken}`,{
                ...params,
                event:1
            }).then((data)=>{
                if(data.code==1){
                    state.user = {
                        ...state.user,
                        nikeName:data.data.nikeName,
                        name:data.data.name,
                        phone:data.data.phone,
                        url:data.data.avatarUrl
                    }
                }
            });
        },

        //发送请求
        Axios(state,params){
            state.loading = true;
            const report_api = sessionStorage.token ? getReportToken : getReport;
            const _this = this;
            axios(`/api${report_api}`, params).then((data) => {
                
                state.loading = false;
                if (data.code != 1) {
                    Toast.fail(data.msg);
                    return;
                }

                // flow_step=20 时切换为商业版模块
                if (Number(data.data.flow_step) === 20) {
                    setModuleVersion('commercial');
                }

                // 同步更新 showModules（版本切换后模块列表会变化）
                state.showModules = getModuleNames();

                // 只对需要显示的模块执行数据清洗
                transformReport(data.data, state.showModules);

                state.info = data.data;

                state.module = {
                    renovate: true,
                    data: data.data.module_list ? data.data.module_list : []
                };

                const flow = sessionStorage.getItem('flow');
                if (flow && JSON.parse(flow).flow_info.report_style == 2) {
                    state.page = 1;
                } else {
                    state.page = 0;
                }

                if (params.report_token) {
                    _this.dispatch('report/axiosUser', {
                        report_token: params.report_token
                    });
                    // 打印公司信息
                    axios(`/api${dayin}`, { report_token: params.report_token }).then((res) => {
                        if (res.code === 1 && res.data) {
                            state.user = { 
                                ...state.user,
                                company:res.data
                            };
                        }
                    });
                }

                // 第三方对接（立创/北京/温岭/携康）
                handleThirdPartyCallback(_this, data.data, flow);
            });
        },
        //发送模块
        SendMin(state,params){
            axios(`/api${get_modules}`,params)
            .then((data)=>{
                state.template_id = data.data.template_id;
                state.module_list = data.data.list;
            });
        },
        //北京 - 上传报告
        GovReport(state,params){
            axios(`/govapi${gov_report}`,params.data,'POST',{
                Authorization:`Bearer ${params.token}`
            }).then((data)=>{
                sessionStorage.removeItem('govReport');
            });
        },
        //温岭 - 上传报告
        WlReport(state,params){
            axios(`/wlapi${wl_report}`,params.data,'POST',{
                'Content-Type':'application/json'
            }).then((data)=>{
                console.log(data);
            });
        }
    },
    actions: {              //异步方法
        axiosData({commit},params){
            commit('Axios',params)
        },
        axiosUser({commit},params){
            commit('User',params)
        },
        meter({commit},params){
            commit('Meter',params)
        },
        broken({commit},params){
            commit('Broken',params)
        },
        radar({commit},params){
            commit('Radar',params)
        },
        cake({commit},params){
            commit('Cake',params)
        },
        axiosSend({commit},params){
            commit('Send',params)
        },
        sendMain({commit},params){
            commit('SendMin',params)
        },
        govToken({commit},params){
            commit('GovToken',params)
        },
        govReport({commit},params){
            commit('GovReport',params)
        },
        wlReport({commit},params){
            commit('WlReport',params)
        }
    },
    getters: {},
}



export default report;